import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '@components/InspirationUpperPagination/InspirationUpperPagination.styles';
type PropsType = {
  initialPage: number;
  handleUpperPaginationButton: () => void;
};
const InspirationUpperPagination = ({
  initialPage,
  handleUpperPaginationButton
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const getPreviousPageUrl = () => {
    const currentPath = router.asPath;
    const hasQuery = currentPath.includes('?');
    const currentPage = parseInt(router.query.page as string, 10) || 1;
    const previousPage = currentPage === 1 ? 1 : currentPage - 1;
    return hasQuery ? currentPath.replace(`page=${currentPage}`, `page=${previousPage}`) : `${currentPath}${currentPath.includes('?') ? '&' : '?'}page=${previousPage}`;
  };
  return <div sx={styles.paginationContainer}>
      {initialPage > 1 && <span>
          <Link href={getPreviousPageUrl()} onClick={e => {
        e.preventDefault();
        handleUpperPaginationButton();
      }} sx={styles.seeMoreButton} data-cy="VoxButtonPaginationPrevious">
            <span>{t('seePrevious')}</span>
          </Link>
        </span>}
    </div>;
};
export default InspirationUpperPagination;